import type { AccessRoleRow } from "../types";

export const ACCESS_ROLE_ROWS: AccessRoleRow[] = [
  {
    id: "company-admin",
    roleKey: "roles-access-page-role-company-admin",
    roleFallback: "Company Admin",
    descriptionKey: "roles-access-page-role-company-admin-desc",
    descriptionFallback:
      "The business owner or main administrator. Manages company settings, all stores, employees, product categories, and company-wide reports."
  },
  {
    id: "store-admin",
    roleKey: "roles-access-page-role-store-admin",
    roleFallback: "Store Admin",
    descriptionKey: "roles-access-page-role-store-admin-desc",
    descriptionFallback:
      "The manager of one store. Manages store staff, products, and daily store operations."
  },
  {
    id: "warehouse-manager",
    roleKey: "roles-access-page-role-warehouse-manager",
    roleFallback: "Warehouse Manager",
    descriptionKey: "roles-access-page-role-warehouse-manager-desc",
    descriptionFallback:
      "Oversees warehouse stock, including stock transfers, adjustments, and inventory accuracy."
  },
  {
    id: "inventory-clerk",
    roleKey: "roles-access-page-role-inventory-clerk",
    roleFallback: "Inventory Clerk",
    descriptionKey: "roles-access-page-role-inventory-clerk-desc",
    descriptionFallback:
      "Handles daily stock activities such as receiving goods, issuing items, and performing stock counts."
  },
  {
    id: "analyst",
    roleKey: "roles-access-page-role-analyst",
    roleFallback: "Analyst",
    descriptionKey: "roles-access-page-role-analyst-desc",
    descriptionFallback:
      "Views dashboards and reports only. This role cannot create, edit, or delete records."
  }
];
